import { FC, Fragment, useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import {
  RecruitListItem_CurrentUserFragment,
  UseGetActivityListFromAdsByPlacementCode_Activity_ActivityWithAdFragment,
} from 'generated/graphql'
import { ACTIVITY_GTM_EVENT } from '@app.feature/ad/constants/gtm'
import { pushGTMCampaignId } from '@app.feature/ad/modules/gtmEvents'
import RecruitListItemMobile from '@app.feature/recruitList/component/recruitListTable/component/mobile/component/RecruitListItem.mobile'

interface IFProps {
  ads: Array<UseGetActivityListFromAdsByPlacementCode_Activity_ActivityWithAdFragment>

  currentUser?: RecruitListItem_CurrentUserFragment | null
}

const NoticeBannerRecruitInternMobile: FC<IFProps> = ({ ads, currentUser }) => {
  const router = useRouter()
  const { pathname } = router
  const processedCampaignIds = useRef<Set<string>>(new Set())

  const getEventNameByPath = () => {
    if (pathname.includes('/intern')) {
      return ACTIVITY_GTM_EVENT.INTERN_NOTICE
    }
    return ACTIVITY_GTM_EVENT.RECRUIT_NOTICE
  }

  const handleOnClickAd = (campaignId?: string) => {
    if (!campaignId) {
      return
    }
    pushGTMCampaignId({
      eventName: getEventNameByPath().MOBILE.CLICK_EVENT,
      campaignId,
    })
  }

  useEffect(() => {
    ads?.forEach((ad) => {
      const campaignId = ad?.ad?.campaign?.id
      if (campaignId && !processedCampaignIds.current.has(campaignId)) {
        processedCampaignIds.current.add(campaignId)
        pushGTMCampaignId({
          eventName: getEventNameByPath().MOBILE.IMPRESSION_EVENT,
          campaignId: campaignId,
        })
      }
    })
  }, [ads])

  return (
    <>
      {ads.map((ad) => {
        const campaignId = ad?.ad?.campaign?.id
        return (
          <Fragment key={`activity-list-intern-item-root-${ad.activity.id}`}>
            <RecruitListItemMobile
              activity={ad.activity}
              currentUser={currentUser}
              isRecommend
              {...(campaignId && {
                linkProps: {
                  onClick: () => handleOnClickAd(campaignId),
                },
              })}
            />
          </Fragment>
        )
      })}
    </>
  )
}

export default NoticeBannerRecruitInternMobile
